import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

/*
 * useTeamTasks — GET /api/surfaces/team/tasks (the brief's Tasks panel rail, Teddy 2026-07-28).
 * The recipient's ACTIVE and ASSIGNED tracker issues, read live from the Linear mirror on the
 * MVP side (recipient-owned integrations only — same scoping law as the Slack-DM Linear triage;
 * mechanical selection, no LLM). `tool` is per-item so Jira/Asana rows slot in later without a
 * contract break. Hand-synced to the MVP contract (TeamTasksResponseSchema, team-surfaces.ts).
 */

export interface TeamTaskItem {
  /** The tracker the item lives in — drives the row's logo. Only 'linear' ships today. */
  tool: 'linear' | string;
  issueId: string;
  identifier?: string | null;
  title?: string | null;
  state?: string | null;
  stateType?: string | null;
  priority?: number | null;
  priorityLabel?: string | null;
  dueDate?: string | null;
  isOverdue?: boolean | null;
  isBlocked?: boolean | null;
  url?: string | null;
  updatedAt?: string | null;
}

export interface TeamTasksResponse {
  status: 'ready' | 'no_team';
  tasks?: {
    connected: boolean;
    items: TeamTaskItem[];
    totalCount: number;
    /** null/undefined = unknown ⇒ keep the check-off ENABLED (the rail 403s if the grant is
     *  read-only). Only an explicit false means "this connection cannot write" — the MVP stores
     *  a scope only when Linear returns one, so unknown is a real and common legacy state. */
    writeCapable?: boolean | null;
  } | null;
}

export function useTeamTasks(enabled: boolean = true) {
  const query = useQuery({
    queryKey: ['surfaces', 'team-tasks'],
    queryFn: () => apiFetch<TeamTasksResponse>('/api/surfaces/team/tasks'),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
  return { ...query, data: query.data ?? undefined };
}
